export function emptyDistributionViewData() {
  return {
    plotKind: "empty",
    xAxisTitle: "",
    rawValues: [],
    categories: [],
    categoryCounts: [],
    validRange: { values: [], label: "Valid Range", count: "-", percent: "-" },
    outsideRange: { count: "-", label: "Outside Range - not available" },
  };
}

function parseValuesRaw(raw) {
  let r = raw;
  if (typeof r === "string") {
    const t = r.trim();
    if (t.startsWith("[") && t.endsWith("]")) {
      try {
        const parsed = JSON.parse(t);
        if (Array.isArray(parsed)) r = parsed;
      } catch {
        /* keep string */
      }
    }
  }
  return r;
}

function unavailableViewData(plot) {
  return {
    plotKind: "unavailable",
    xAxisTitle: plot.DisplayName || plot.Name || "",
    rawValues: [],
    categories: [],
    categoryCounts: [],
    validRange: { values: [], label: "", count: "-", percent: "" },
    outsideRange: { count: "-", label: "" },
  };
}

export function mapDistributionPlotToViewData(plot) {
  if (!plot) return null;

  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
  };

  const raw = parseValuesRaw(plot.Values);

  if (raw === null || raw === undefined) {
    return unavailableViewData(plot);
  }

  if (!Array.isArray(raw)) {
    return unavailableViewData(plot);
  }

  const valueList = raw.map(toNum).filter((n) => !Number.isNaN(n));
  if (valueList.length === 0) {
    return unavailableViewData(plot);
  }

  return {
    plotKind: "histogram",
    xAxisTitle: plot.DisplayName || plot.Name || "",
    rawValues: valueList,
    categories: [],
    categoryCounts: [],
    validRange: {
      values: [],
      label: "Samples",
      count: valueList.length,
      percent: "",
    },
    outsideRange: { count: "-", label: "" },
  };
}

export const DL_MATERIAL_BALANCE_PLOT_ORDER = ["ForwardBackwardMoles", "STODensityError", "RsError"];

export const DL_FEED_DEVIATION_PLOT_NAMES = [
  "OverallFeedDeviation",
  "OverallFeedDeviationDL",
  "FeedDeviationMolePercent",
  "MudResFMoleFraction",
];
